export const START_SURVEY = 'START_SURVEY';
export const CHOOSE_ANSWER = 'CHOOSE_ANSWER';
export const NEXT_QUESTION = 'NEXT_QUESTION';
export const PREVIOUS_QUESTION = 'PREVIOUS_QUESTION';
export const GO_BACK = 'GO_BACK';
// TODO: Possibly refactor to use just one action for navigating questions.
export const GO_TO_QUESTION = 'GO_TO_QUESTION';
export const SET_INITIAL_STATE = 'SET_INITIAL_STATE';
export const SET_INITIAL_STATE_LOCAL_STORAGE = 'SET_INITIAL_STATE_LOCAL_STORAGE';
export const QUOTE_SAVED = 'QUOTE_SAVED';
export const RESET_QUOTE = 'RESET_QUOTE';
export const SET_MODE = 'SET_MODE';
